// extracted by mini-css-extract-plugin
module.exports = {"clock":"ClockTimer_clock__GYyBd","wrapper":"ClockTimer_wrapper__2jvIC"};